import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-200 h-screen overflow-y-auto pb-32" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Nav = _resolveComponent("Nav")
  const _component_LoginModal = _resolveComponent("LoginModal")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Nav),
    _createVNode(_component_LoginModal, { show: _ctx.showLoginModal }, null, 8, ["show"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}